import React, { useState, useEffect } from "react";
// @ts-ignore
import Modal from 'react-bootstrap/Modal';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';


import Phone from "../../../assets/images/phone.png";
import Lte from "../../../assets/images/lte.png";

import * as BiIcons from "react-icons/bi";
import * as BsIcons from "react-icons/bs";
import * as FcIcons from "react-icons/fc";
import * as AiIcons from "react-icons/ai";

import './styles.css';

const Planos = () => {

    const [fullscreen ] = useState(true);

  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);

  const handleCloseModal1 = () => setShowModal1(false);
  const handleCloseModal2 = () => setShowModal2(false);
  const handleCloseModal3 = () => setShowModal3(false);
  const handleCloseModal4 = () => setShowModal4(false);

  const handleOpenModal1 = () => setShowModal1(true);
  const handleOpenModal2 = () => setShowModal2(true);
  const handleOpenModal3 = () => setShowModal3(true);
  const handleOpenModal4 = () => setShowModal4(true);
  

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);
    return (
        <div className="container plan">
      <div className="row  py-4">
        <h1>Telefonia Fixa GigaPhone</h1>
        <h4>Instruções para auxiliar o Cliente na escolha do plano de telefone fixo</h4>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-phone">
                <img src={Phone} alt="foto" />
                <h2> URBANO LITE  </h2>
              </div>
              <Card.Header></Card.Header>

              <Card.Body>

                <Card.Text>
                  <div className="img-icon">
                    <BiIcons.BiPhoneCall />
                    <span>1000 minutos</span>
                    <p>LIGAÇÕES PARA LOCAL FIXO, NÃO LIGA PARA CELULARES E FIXO DE OUTRAS CIDADES </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcApproval /><span>Funciona via internet</span>
                    <p>inteligado com todas as grandes operadoras de telefonia fixa </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcFlashOn />
                    <span>Instalação rápida</span>
                    <p>o prazo de instalação pode variar conforme a cidade </p>
                  </div>
                  <div className="img-icon">
                    <BsIcons.BsArrowClockwise />
                    <span>Portabilidade</span>
                    <p>disponível para qualquer operadora fixa</p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcUpRight />
                    <span>Siga-me</span>
                    <p>Esse recurso permite redirecionar as chamadas de um número para outro, possibilitando atender ligações em diferentes dispositivos.</p>
                  </div>
                  <div className="img-icon">
                    <AiIcons.AiFillEye />
                    <span>Identificador de chamadas</span>
                    <p>identificador de chamadas incluso em todos os planos (o aparelho tem que ser compatível)</p>
                    <div className="img-icon-content">
                      
                    </div>
                  </div>
                  <div className="price">                    
                    <span>
                      por R$ 30,00/MÊS
                    </span>
                    <hr />
                    <p>
                    Atenção! Em caso de portabilidade, oriente o cliente a NÃO CANCELAR a linha com a operadora. Após fechar o contrato, a Gigabyte solicitará a portabilidade do número de telefone.
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary" onClick={handleOpenModal1}>Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <Modal show={showModal1} onHide={handleCloseModal1} size="lg" className="custom-modal">
          <Modal.Header closeButton>
            <Modal.Title>????????????????????</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ListGroup as="ol">
              <ListGroup.Item as="li">??????????</ListGroup.Item>
              
            </ListGroup>
            <br />
            <h5>Recomendações:</h5>
            <ListGroup as="ol">
              <ListGroup.Item as="li">??????????</ListGroup.Item>
              <ListGroup.Item as="li">??????????</ListGroup.Item>
              <ListGroup.Item as="li"><Card.Link href="https://emulator.tp-link.com/c20-v5-br/index.htm" target="_blank">Emulador</Card.Link></ListGroup.Item>
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={handleCloseModal1}>Fechar</Button>
          </Modal.Footer>
        </Modal>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
            <div className="img-icon-phone">
                <img src={Phone} alt="foto" />
                <h2> URBANO PLUS  </h2>
              </div>
              <Card.Header></Card.Header>

              <Card.Body>

              <Card.Text>
                  <div className="img-icon">
                    <BiIcons.BiPhoneCall />
                    <span>1000 minutos</span>
                    <p>LIGAÇÕES PARA QUALQUER OPERADORA </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcApproval /><span>Funciona via internet</span>
                    <p>inteligado com todas as grandes operadoras de telefonia fixa </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcFlashOn />
                    <span>Instalação rápida</span>
                    <p>o prazo de instalação pode variar conforme a cidade </p>
                  </div>
                  <div className="img-icon">
                    <BsIcons.BsArrowClockwise />
                    <span>Portabilidade</span>
                    <p>disponível para qualquer operadora fixa</p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcUpRight />
                    <span>Siga-me</span>
                    <p>Esse recurso permite redirecionar as chamadas de um número para outro, possibilitando atender ligações em diferentes dispositivos.</p>
                  </div>
                  <div className="img-icon">
                    <AiIcons.AiFillEye />
                    <span>Identificador de chamadas</span>
                    <p>identificador de chamadas incluso em todos os planos (o aparelho tem que ser compatível)</p>
                    <div className="img-icon-content">
                      
                    </div>
                  </div>
                  <div className="price">                    
                    <span>
                      por R$ 60,00/MÊS
                    </span>
                    <hr />
                    <p>
                    Atenção! Em caso de portabilidade, oriente o cliente a NÃO CANCELAR a linha com a operadora. Após fechar o contrato, a Gigabyte solicitará a portabilidade do número de telefone. 
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary" onClick={handleOpenModal2}>Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <Modal show={showModal2} onHide={handleCloseModal2} size="lg" className="custom-modal">
          <Modal.Header closeButton>
            <Modal.Title>????????????????????</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ListGroup as="ol">
              <ListGroup.Item as="li">??????????</ListGroup.Item>
              
            </ListGroup>
            <br />
            <h5>Recomendações:</h5>
            <ListGroup as="ol">
              <ListGroup.Item as="li">??????????</ListGroup.Item>
              <ListGroup.Item as="li">??????????</ListGroup.Item>
              <ListGroup.Item as="li"><Card.Link href="https://emulator.tp-link.com/c20-v5-br/index.htm" target="_blank">Emulador</Card.Link></ListGroup.Item>
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={handleCloseModal2}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
            <div className="img-icon-phone">
                <img src={Phone} alt="foto" />
                <h2> RURAL LITE  </h2>
              </div>
              <Card.Header></Card.Header>
              <Card.Body>
              <Card.Text>
                  <div className="img-icon">
                    <BiIcons.BiPhoneCall />
                    <span>1000 minutos</span>
                    <p>LIGAÇÕES PARA LOCAL FIXO, NÃO LIGA PARA CELULARES E FIXO DE OUTRAS CIDADES </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcApproval /><span>Funciona via internet</span>
                    <p>inteligado com todas as grandes operadoras de telefonia fixa </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcFlashOn />
                    <span>Instalação rápida</span>
                    <p>o prazo de instalação pode variar conforme a cidade </p>
                  </div>
                  <div className="img-icon">
                    <BsIcons.BsArrowClockwise />
                    <span>Portabilidade</span>
                    <p>disponível para qualquer operadora fixa</p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcUpRight />
                    <span>Siga-me</span>
                    <p>Esse recurso permite redirecionar as chamadas de um número para outro, possibilitando atender ligações em diferentes dispositivos.</p>
                  </div>
                  <div className="img-icon">
                    <AiIcons.AiFillEye />
                    <span>Identificador de chamadas</span>
                    <p>identificador de chamadas incluso em todos os planos (o aparelho tem que ser compatível)</p>
                    <div className="img-icon-content">
                      
                    </div>
                  </div>
                  <div className="price">                    
                    <span>
                      por R$ 50,00/MÊS
                    </span>
                    <hr />
                    <p>
                    Atenção! Em caso de portabilidade, oriente o cliente a NÃO CANCELAR a linha com a operadora. Após fechar o contrato, a Gigabyte solicitará a portabilidade do número de telefone.
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary" onClick={handleOpenModal3}>Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <Modal show={showModal3} onHide={handleCloseModal3} size="lg" className="custom-modal">
          <Modal.Header closeButton>
            <Modal.Title>I???????????????</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ListGroup as="ol">
              <ListGroup.Item as="li">??????????</ListGroup.Item>              
            </ListGroup>
            <br />
            <h5>Recomendações:</h5>
            <ListGroup as="ol">
              <ListGroup.Item as="li">?????????</ListGroup.Item>
              <ListGroup.Item as="li">???????????</ListGroup.Item>
              <ListGroup.Item as="li"><Card.Link href="" target="_blank">Link</Card.Link></ListGroup.Item>
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={handleCloseModal3}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
            <div className="img-icon-phone">
                <img src={Phone} alt="foto" />
                <h2> RURAL PLUS  </h2>
              </div>
              <Card.Header></Card.Header>
              <Card.Body>
              <Card.Text>
                  <div className="img-icon">
                    <BiIcons.BiPhoneCall />
                    <span>1000 minutos</span>
                    <p>LIGAÇÕES PARA QUALQUER OPERADORA </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcApproval /><span>Funciona via internet</span>
                    <p>inteligado com todas as grandes operadoras de telefonia fixa </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcFlashOn />
                    <span>Instalação rápida</span>
                    <p>o prazo de instalação pode variar conforme a cidade </p>
                  </div>
                  <div className="img-icon">
                    <BsIcons.BsArrowClockwise />
                    <span>Portabilidade</span>
                    <p>disponível para qualquer operadora fixa</p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcUpRight />
                    <span>Siga-me</span>
                    <p>Esse recurso permite redirecionar as chamadas de um número para outro, possibilitando atender ligações em diferentes dispositivos.</p>
                  </div>
                  <div className="img-icon">
                    <AiIcons.AiFillEye />
                    <span>Identificador de chamadas</span>
                    <p>identificador de chamadas incluso em todos os planos (o aparelho tem que ser compatível)</p>
                    <div className="img-icon-content">
                      
                    </div>
                  </div>
                  <div className="price">                    
                    <span>
                      por R$ 100,00/MÊS
                    </span>
                    <hr />
                    <p>
                    Atenção! Em caso de portabilidade, oriente o cliente a NÃO CANCELAR a linha com a operadora. Após fechar o contrato, a Gigabyte solicitará a portabilidade do número de telefone.
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary" onClick={handleOpenModal4}>Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>

      <Modal show={showModal4} onHide={handleCloseModal4} fullscreen={fullscreen} >
        <Modal.Header closeButton>
          <Modal.Title><div className="img-title"><img src={Lte} alt="foto" /> </div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
         
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" onClick={handleCloseModal4}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
      
      <div className="end"></div>
    </div>
    );
}
export default Planos;